import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_check-basic",
  "use": "icon_check-basic-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_check-basic\"><path d=\"M17.5858 38.3284L4.58576 25.3284C3.80475 24.5474 3.80475 23.2811 4.58576 22.5L7.41412 19.6715C8.19514 18.8904 9.46155 18.8904 10.2426 19.6715L19 28.4289L37.7574 9.67152C38.5385 8.8905 39.8049 8.8905 40.5859 9.67152L43.4142 12.5C44.1953 13.281 44.1953 14.5473 43.4142 15.3284L20.4142 38.3285C19.6331 39.1095 18.3668 39.1095 17.5858 38.3284Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol